import { Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';

import { unoTheme } from '../../../../../../assets/styles/unoTheme';

export const TRADEMATE_STATUS_LABELS = {
    DRAFT: 'Em preenchimento',
    SENT: 'Enviado',
    REOPENED: 'Reaberto',
};

const STATUS_COLORS = {
    DRAFT: unoTheme.warningColor,
    SENT: unoTheme.successColor,
    REOPENED: unoTheme.mainColor,
};

const useStyles = makeStyles({
    //O chip é filho direto do slot flex do header (rightHeader), que já centraliza verticalmente.
    //`flex: 0 0 auto` impede que ele encolha quando o stepper disputa a largura.
    chip: {
        padding: '2px 10px',
        borderRadius: '12px',
        color: 'white',
        fontSize: '11px',
        fontWeight: 600,
        whiteSpace: 'nowrap',
        flex: '0 0 auto',
        cursor: 'default',
    },
});

/**
 * Selo de estado da ficha do Cadastro Trademate, renderizado no header ao lado do stepper.
 *
 * Componente separado porque o `AccreditationScreen` já hospeda o slot compartilhado das quatro
 * abas — colar este markup lá dentro pioraria a leitura de um arquivo que não é do Trademate.
 *
 * @param {{registration: {status: string, sent_at: string, sent_by_name: string}}} props
 */
export default function TrademateStatusChip(props) {

    const { registration } = props;

    const classes = useStyles();

    if (!registration || !registration.status) return null;

    const status = registration.status;
    const isSent = status === 'SENT';

    const chip = (
        <span className={classes.chip} style={{ background: STATUS_COLORS[status] }}>
            {TRADEMATE_STATUS_LABELS[status]}
        </span>
    );

    //Quem enviou e quando vira tooltip, e não texto ao lado: o slot do header divide espaço com o
    //stepper e com as abas, e essa linha é a mais longa de todas.
    if (!isSent || !registration.sent_at) return chip;

    const sentInfo = 'Enviado por '
        + (registration.sent_by_name ? registration.sent_by_name : '-')
        + ' em ' + new Date(registration.sent_at).toLocaleString('pt-BR');

    return (
        //O Tooltip precisa passar ref para o filho; um <span> é elemento DOM e aceita
        <Tooltip title={sentInfo} arrow>
            {chip}
        </Tooltip>
    );
}
